export const MAX_HEIGHT = 107;
export const MAX_WEIGHT = 999;
export const KG_PER_LB = 0.453592;
export const INCHES_PER_CM = 0.393701;
